import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Col, Container, Form, Modal, Row, Stack } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHTextarea from '../../FunctionalComponent/FormElement/RHTextarea';
import { toast } from 'react-toastify';
import { useCreate_Update_termsConditionMutation, useTermsConditionlistQuery } from '../../Redux/termsCondition/termsConditionApi';
import BreadCrumb from '../../Common/BreadCrumb';





function CreateTermsCondition() {
    const [CreateUpdateReturnPolicyFunc, { isLoading, isSuccess, error, data: responseData }] = useCreate_Update_termsConditionMutation();
    const { data: listData, isLoading: listLoading } = useTermsConditionlistQuery();
    const [toastId, setToastId] = useState(null)

    console.log(listData, "listData");
    let title = {
        header: `Terms & Condition ${listData?.response?.id ? 'Update' : 'Add'}`,
        submit: `${listData?.response?.id ? 'Update' : 'Save'}`
    };

    let initialState = {
        id: '',
        termsAndCondition: '',
    };

    const schema = Yup
        .object({
            termsAndCondition: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),
        })
        .required();

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
    } = methods;

    const onSubmit = () => {
        const data = getValues();
        const tid = toast.loading("Loading...");
        setToastId(tid)

        CreateUpdateReturnPolicyFunc({ ...data })
    }

    useEffect(() => {
        if (isSuccess) {
            const message = responseData?.message || "Product created successfully";
            toast.update(toastId, {
                render: message,
                type: "success",
                isLoading: false
            })
            reset()
        }
        if (error) {
            if ('data' in error) {
                const errorData = error;
                // toast.error(errorData.responseData.message);
                toast.update(toastId, {
                    render: errorData?.responseData?.message,
                    type: "error",
                    isLoading: false
                })

            }
        }
    }, [responseData, isSuccess, error]);

    useEffect(() => {

        if (listData?.response?.id) {
            Object.keys(initialState).forEach(it => {
                setValue(it, listData?.response?.[it])
            })
        }

    }, [listData?.response])


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <BreadCrumb title={title?.header} pageTitle="More" />

                    <FormProvider className="tablelist-form mt-4" methods={methods} onSubmit={handleSubmit(onSubmit)} >
                        <Row className='justify-content-center'>
                            <Col lg={8}>
                                <Row>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <RHTextarea label='Terms & Condition' name='termsAndCondition' placeholder="termsAndCondition" rows={3} />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='justify-content-center mt-4'>
                            <Col lg={8} className="modal-footer">
                                <Row>
                                    <Col xs={12}>
                                        <div className="hstack gap-2 justify-content-end">
                                            <Button variant='primary' id="add-btn" type="submit">{title?.submit}</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </FormProvider>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default CreateTermsCondition;
